<template>
  <div>
    <a-row>
      <a-col :span="12">
        <a-descriptions
          title="基本信息"
          :column="1"
          class="simiot-descriptions"
        >
          <a-descriptions-item label="名称">
            {{ moduleSupplier.name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人">
            {{ moduleSupplier.contact_name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人电话">
            {{ moduleSupplier.contact_phone }}
          </a-descriptions-item>

          <a-descriptions-item label="模组总量">
            {{ moduleSupplier.module_total_count }}
          </a-descriptions-item>

          <a-descriptions-item label="库存量">
            {{ moduleSupplier.module_stock_count }}
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            {{ moduleSupplier.remark }}
          </a-descriptions-item>

          <a-descriptions-item label="创建时间">
            {{ moduleSupplier.created_at }}
          </a-descriptions-item>

          <a-descriptions-item label="更新时间">
            {{ moduleSupplier.updated_at }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findModuleSupplier } from '@/api/module_supplier'

export default {
  name: 'ShowModuleSupplier',
  data() {
    return {
      moduleSupplier: {}
    }
  },
  computed: {
    moduleSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findModuleSupplier(this.moduleSupplierId).then((res) => {
        if (res.code === 0) {
          this.moduleSupplier = res.data
        }
      })
    }
  }
}
</script>
